import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import Card from 'components/card';
import { useParams } from 'react-router-dom';
import GoBack from 'components/actions/GoBack';
import {
    MdDisplaySettings,
    MdDoneOutline,
    MdOutlinePayment,
    MdOutlineRocketLaunch,
    MdInbox,
} from 'react-icons/md';
import { getImage } from 'variables/images';
import OrderStatus from 'views/admin/main/ecommerce/orderDetails/components/OrderStatus';
import { toast } from 'react-toastify';
import { TbTrash } from 'react-icons/tb';

const BuyerOfferPage = () => {
    const [user, setUser] = useState<any>(null);
    const [offer, setOffer] = useState<any>({});
    const params = useParams();

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                setUser(res.data);
                if (res.data && res.data.type !== 'buyer') {
                    window.location.href = '/admin/my-request';
                }
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const initSheetUrl = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/offer/buyer-sheet/${params.id}`, config)
            .then((res) => {
                // Sheet URL loaded
            })
            .catch((err) => {
                console.log('url error', err);
            });
    };

    const getOffer = (id: string) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/offer/${id}`, config)
            .then((res) => {
                setOffer(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const deleteOffer = (id: string) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .delete(`${CONFIG.apiUrl}/seller-offer/${id}`, config)
            .then((res) => {
                console.log('Offer deleted');
                window.location.href = '/';
                toast.success('Votre offre a été supprimée avec succès !');
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';
        getOffer(params.id);
        initUser();
        initSheetUrl();
        // eslint-disable-next-line
    }, []);

    const InfoBox = (props: {
        icon?: any;
        title?: string;
        description?: string;
    }) => {
        const { icon, title, description } = props;
        return (
            <div className="w-full rounded-[20px] bg-lightPrimary p-6 dark:!bg-navy-700">
                <div className="grid grid-cols-12 gap-0">
                    <div className="col-span-1 text-gray-900">{icon}</div>
                    <h4 className="col-span-10 text-lg font-bold text-gray-900 dark:text-white">
                        {title}
                    </h4>
                </div>
                <p className="mt-[12px] whitespace-pre-line pr-2 text-sm text-gray-700 dark:text-white">
                    {description}
                </p>
            </div>
        );
    };

    return (
        <div className="min-h-screen pb-10">
            <GoBack />
            <div className="mt-3 h-full w-full gap-2 rounded-[20px]">
                <Card
                    extra={
                        'relative w-full pb-[30px] pt-[20px] px-[29px] h-fit shadow-lg rounded-[20px] border border-gray-200 dark:border-navy-700'
                    }
                >
                    {/* Delete offer if I'm the owner */}
                    {user?._id === offer?.buyerId && (
                        <div className="absolute right-5 top-5">
                            <button
                                className="linear flex h-fit w-fit items-center gap-2 rounded-xl border-2 border-red-500 px-4 py-2 text-sm font-medium text-red-500 transition duration-200 hover:bg-red-600/5 active:bg-red-700/5 dark:hover:bg-red-500/10"
                                onClick={(e: any) => deleteOffer(offer._id)}
                            >
                                <TbTrash className="" />
                                <span className="hidden md:inline">Supprimer</span>
                            </button>
                        </div>
                    )}
                    {/* Header */}
                    <div className="mt-1">
                        <div>
                            <p className="mt-5 text-sm font-semibold uppercase tracking-wide text-blue-600 dark:text-blue-400">
                                {offer?.subIndustry}
                            </p>
                            <h1 className="mt-2 text-3xl font-bold text-navy-900 dark:text-white">
                                {offer?.industry}
                            </h1>
                            <p className="mb-5 mt-1 text-sm font-medium text-gray-500 dark:text-gray-400">
                                Commande #{offer?.offerBuyerNumber}
                            </p>
                            <div className="mb-5 mt-5 h-px w-full bg-gradient-to-r from-transparent via-gray-300 to-transparent dark:via-navy-600"></div>
                            
                            {/* Main Content Grid */}
                            <div className="grid grid-cols-1 lg:grid-cols-2">
                                {/* Left side - Image */}
                                <div>
                                    {getImage(
                                        offer?.industry,
                                        offer?.subIndustry
                                    ) ? (
                                        <img
                                            src={getImage(
                                                offer?.industry,
                                                offer?.subIndustry
                                            )}
                                            className="mb-4 h-auto w-[400px] rounded-xl shadow-md"
                                            alt={`${offer?.industry} ${offer?.subIndustry}`}
                                        />
                                    ) : (
                                        <div className="flex h-[400px] w-full items-center justify-center rounded-xl bg-gradient-to-br from-gray-400 to-gray-600 shadow-md">
                                            <p className="text-white">
                                                {offer?.industry} -{' '}
                                                {offer?.subIndustry}
                                            </p>
                                        </div>
                                    )}
                                    {offer?.status !== 'running' && (
                                        <div className="mt-3">
                                            <OrderStatus offer={offer} />
                                        </div>
                                    )}
                                </div>

                                {/* Right side - Status and CTA */}
                                <div className="space-y-2">
                            {/* Offer status */}
                            <div>
                                {offer?.status === 'done' && (
                                    <InfoBox
                                        icon={<MdDoneOutline size={30} />}
                                        title={'Mission terminée'}
                                        description={`Vous avez généré ${
                                            offer?.leadsGenerated
                                        } leads (${
                                            offer?.leadsGenerated *
                                            offer?.sellerPrice?.toFixed(2)
                                        }€). Profitez de cette traction et cherchez un autre acheteur avec le même besoin.`}
                                    />
                                )}
                                {offer?.status === 'on_market' &&
                                    user &&
                                    user.isValidated && (
                                        <InfoBox
                                            icon={
                                                <MdDisplaySettings size={30} />
                                            }
                                            title={'Paramétrage de la campagne'}
                                            description={`Votre campagne est en cours de paramétrage. Vous receverez un mail avec un lien de paiement une fois que tout sera prêt !`}
                                        />
                                    )}
                                {offer?.status === 'on_market' &&
                                    user &&
                                    !user.isValidated && (
                                        <InfoBox
                                            icon={
                                                <MdDisplaySettings size={30} />
                                            }
                                            title={'En attente de validation'}
                                            description={`Votre compte doit être validé par un administrateur, votre offre sera publiée une fois que ce sera fait.`}
                                        />
                                    )}
                                {offer?.status === 'waiting_payment' && (
                                    <>
                                        <InfoBox
                                            icon={<MdOutlinePayment size={30} />}
                                            title={'En attente de paiement'}
                                            description={`Vous pouvez commander ${
                                                offer.weeklyQuantity
                                            } leads à ${offer.buyerPrice?.toFixed(
                                                2
                                            )}€ l'unité. Votre campagne commence une fois la commande payée.\nVotre argent reste sous séquestre jusqu'à la livraison complète.`}
                                        />
                                        <button
                                            className="data-rewardful linear mt-4 w-full rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-3 text-base font-semibold text-white shadow-md transition duration-200 hover:from-green-600 hover:to-emerald-700 hover:shadow-lg active:scale-95 md:w-auto"
                                            onClick={() => {
                                                window.location.href = `${CONFIG.apiUrl}/stripe/checkout/${offer._id}/${user._id}`;
                                            }}
                                        >
                                            💳 Payer{' '}
                                            {(offer.buyerPrice?.toFixed(2) *
                                                offer.weeklyQuantity).toFixed(2)}
                                            €
                                        </button>
                                    </>
                                )}
                                {offer?.status === 'running' && (
                                    <>
                                        <p className="mb-3 text-gray-700 dark:text-gray-300">
                                            💡 Délai de livraison : jusqu'à 2
                                            semaines après réception du
                                            paiement, variable selon le volume
                                            commandé.
                                        </p>
                                        <InfoBox
                                            icon={
                                                <MdOutlineRocketLaunch
                                                    size={30}
                                                />
                                            }
                                            title={'Mission en cours'}
                                            description={`Vous avez déjà reçu ${
                                                offer.leadsGenerated
                                            } leads pour cette mission. Cela représente ${
                                                offer.leadsGenerated *
                                                offer.buyerPrice?.toFixed(2)
                                            }€.`}
                                        />
                                        
                                        {/* CTA to leads inbox */}
                                        <div className="mt-4 rounded-[20px] border-2 border-leadrs/50 bg-gradient-to-r from-blue-50 to-indigo-50 p-6 shadow-md dark:from-navy-800 dark:to-navy-700">
                                            <div className="flex items-start gap-4">
                                                <div className="rounded-full bg-leadrs p-3 text-white">
                                                    <MdInbox size={24} />
                                                </div>
                                                <div className="flex-1">
                                                    <h3 className="mb-2 text-lg font-bold text-navy-900 dark:text-white">
                                                        Accédez à vos leads
                                                    </h3>
                                                    <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">
                                                        Tous vos leads sont centralisés dans votre boîte de réception. 
                                                        Consultez les coordonnées complètes et suivez votre progression en temps réel.
                                                    </p>
                                                    <button
                                                        className="linear flex items-center gap-2 rounded-xl bg-gradient-to-r from-leadrs to-leadrs/80 px-6 py-3 text-sm font-semibold text-white shadow-md transition duration-200 hover:from-blue-600 hover:to-indigo-700 hover:shadow-lg active:scale-95"
                                                        onClick={() => {
                                                            window.location.href = '/admin/leads';
                                                        }}
                                                    >
                                                        <MdInbox size={20} />
                                                        Voir mes leads
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            </div>
                            </div>
                            
                            {/* Details Section */}
                            <div className="mt-8 space-y-4">
                                <h2 className="mb-4 text-xl font-bold text-navy-900 dark:text-white">
                                    Détails de la commande
                                </h2>
                                
                                <div className="rounded-xl bg-gray-50 p-4 dark:bg-navy-800">
                                    <p className="mb-1 text-sm font-semibold text-navy-700 dark:text-gray-300">
                                        Quantité
                                    </p>
                                    <p className="text-base text-gray-900 dark:text-white">
                                        {offer?.weeklyQuantity} leads
                                    </p>
                                </div>
                                
                                <div className="rounded-xl bg-gray-50 p-4 dark:bg-navy-800">
                                    <p className="mb-1 text-sm font-semibold text-navy-700 dark:text-gray-300">
                                        Canaux d'acquisition
                                    </p>
                                    <div className="flex flex-wrap gap-2">
                                        {offer?.channels?.map((channel: string, index: number) => (
                                            <span 
                                                key={index}
                                                className="rounded-lg bg-blue-100 px-3 py-1 text-sm font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
                                            >
                                                {channel}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                                
                                <div className="rounded-xl bg-gray-50 p-4 dark:bg-navy-800">
                                    <p className="mb-1 text-sm font-semibold text-navy-700 dark:text-gray-300">
                                        Champs de données
                                    </p>
                                    <div className="flex flex-wrap gap-2">
                                        {offer?.fields?.map((field: string, index: number) => (
                                            <span 
                                                key={index}
                                                className="rounded-lg bg-purple-100 px-3 py-1 text-sm font-medium text-purple-700 dark:bg-purple-900/30 dark:text-purple-300"
                                            >
                                                {field}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                                
                                <div className="rounded-xl bg-gray-50 p-4 dark:bg-navy-800">
                                    <p className="mb-1 text-sm font-semibold text-navy-700 dark:text-gray-300">
                                        Type de besoin
                                    </p>
                                    <p className="text-base capitalize text-gray-900 dark:text-white">
                                        {offer?.type}
                                    </p>
                                </div>
                                
                                <div className="rounded-xl bg-gray-50 p-4 dark:bg-navy-800">
                                    <p className="mb-2 text-sm font-semibold text-navy-700 dark:text-gray-300">
                                        Départements
                                    </p>
                                    <div className="flex flex-wrap gap-2">
                                        {offer?.regions?.map((region: string, index: number) => (
                                            <span 
                                                key={index}
                                                className="rounded-lg bg-green-100 px-3 py-1 text-sm font-medium text-green-700 dark:bg-green-900/30 dark:text-green-300"
                                            >
                                                {region}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default BuyerOfferPage;
